// src/mixins/mouseEffect.js
export default {
    data() {
        return {
            cursorElement: null,
            scannerElement: null,
            isMobileDevice: false
        }
    },

    mounted() {
        this.initMouseEffect();
    },

    beforeDestroy() {
        this.cleanupMouseEffect();
    },

    methods: {
        // 检测移动设备
        checkIfMobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent || navigator.vendor || window.opera
            );
        },

        // 初始化鼠标效果
        initMouseEffect() {
            this.isMobileDevice = this.checkIfMobile();

            if (this.isMobileDevice) {
                console.log('移动设备，不启用自定义鼠标');
                return;
            }

            // 1. 隐藏默认光标
            document.body.style.cursor = 'none';

            // 2. 创建扫描线
            this.scannerElement = document.createElement('div');
            this.scannerElement.id = 'ice-soul-scanner-line';
            this.scannerElement.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background: #00D1FF;
        z-index: 999999;
        pointer-events: none;
        box-shadow: 0 0 15px #00D1FF;
        opacity: 0.8;
        transform: translateY(-50%);
        transition: none; /* 移除过渡效果，实现实时跟随 */
      `;
            document.body.appendChild(this.scannerElement);

            // 3. 创建自定义光标
            this.cursorElement = document.createElement('div');
            this.cursorElement.id = 'ice-soul-custom-cursor';
            this.cursorElement.style.cssText = `
        position: fixed;
        width: 40px;
        height: 40px;
        border: 1px solid #00D1FF;
        border-radius: 50%;
        pointer-events: none;
        z-index: 999999;
        transition: transform 0.15s ease-out, background 0.15s ease-out;
        display: flex;
        align-items: center;
        justify-content: center;
        left: 0;
        top: 0;
      `;

            const cursorDot = document.createElement('div');
            cursorDot.style.cssText = `
        width: 4px;
        height: 4px;
        background: #00D1FF;
        border-radius: 50%;
      `;
            this.cursorElement.appendChild(cursorDot);
            document.body.appendChild(this.cursorElement);

            // 4. 绑定事件
            document.addEventListener('mousemove', this.handleMouseMove);
            document.addEventListener('mouseover', this.handleMouseOver, { passive: true });
            document.addEventListener('mouseout', this.handleMouseOut, { passive: true });

            // 5. 监听路由变化
            this.$router.afterEach(() => {
                this.$nextTick(() => {
                    this.bindHoverElements();
                });
            });

            // 6. 初始绑定悬停元素
            this.bindHoverElements();
        },

        // 鼠标移动
        handleMouseMove(event) {
            if (!this.cursorElement || !this.scannerElement) return;

            this.cursorElement.style.left = (event.clientX - 20) + 'px';
            this.cursorElement.style.top = (event.clientY - 20) + 'px';

            // 修改：实时更新扫描线位置，无延迟
            this.scannerElement.style.transform = `translateY(${event.clientY - 0.5}px)`; // 0.5是half pixel

            // 视差效果
            this.handleParallaxEffect(event);
        },

        // 鼠标悬停
        handleMouseOver(event) {
            if (!this.cursorElement) return;

            const target = event.target;
            const hoverSelectors = ['a', 'button', '.stack-item', '.terminal-card', '.spec-card', '.download-btn'];

            for (const selector of hoverSelectors) {
                if (target.matches(selector) || target.closest(selector)) {
                    this.cursorElement.style.transform = 'scale(1.5)';
                    this.cursorElement.style.background = 'rgba(0, 209, 255, 0.1)';
                    return;
                }
            }
        },

        // 鼠标离开
        handleMouseOut() {
            if (!this.cursorElement) return;

            this.cursorElement.style.transform = 'scale(1)';
            this.cursorElement.style.background = 'transparent';
        },

        // 视差效果
        handleParallaxEffect(event) {
            const outlineText = document.querySelector('.bg-outline-text');
            if (outlineText) {
                const x = (window.innerWidth / 2 - event.clientX) / 30;
                const y = (window.innerHeight / 2 - event.clientY) / 30;
                outlineText.style.transform = `translate(${x}px, ${y}px)`;
            }
        },

        // 绑定悬停元素
        bindHoverElements() {
            const hoverSelectors = ['a', 'button', '.stack-item', '.terminal-card', '.spec-card', '.download-btn'];
            hoverSelectors.forEach(selector => {
                const elements = document.querySelectorAll(selector);
                elements.forEach(el => {
                    el.style.cursor = 'none';
                });
            });
        },

        // 清理
        cleanupMouseEffect() {
            if (this.cursorElement && this.cursorElement.parentNode) {
                this.cursorElement.parentNode.removeChild(this.cursorElement);
            }
            if (this.scannerElement && this.scannerElement.parentNode) {
                this.scannerElement.parentNode.removeChild(this.scannerElement);
            }

            document.removeEventListener('mousemove', this.handleMouseMove);
            document.removeEventListener('mouseover', this.handleMouseOver);
            document.removeEventListener('mouseout', this.handleMouseOut);
            document.body.style.cursor = '';
        }
    },

    // 绑定this
    created() {
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.handleMouseOver = this.handleMouseOver.bind(this);
        this.handleMouseOut = this.handleMouseOut.bind(this);
    }
}